import { Phone, CalendarCheck, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { SITE, waLink, telLink } from "../data/siteConfig";

const base =
  "inline-flex min-h-[44px] items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold transition-[transform,box-shadow,background-color] duration-200 hover:-translate-y-0.5 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-[#1E88E5] focus:ring-offset-2";

export const btnPrimary = `${base} bg-[#1E88E5] text-white hover:bg-[#1565C0]`;
export const btnDark = `${base} bg-[#0B3056] text-white hover:bg-[#0d3a68]`;
export const btnWhite = `${base} bg-white text-[#0B3056] hover:bg-[#F0F7FA]`;
export const btnOutline = `${base} border-2 border-[#1E88E5] bg-transparent text-[#1E88E5] hover:bg-[#F0F7FA]`;
export const btnOutlineWhite = `${base} border-2 border-white/80 bg-transparent text-white hover:bg-white/10`;
export const btnWhatsApp = `${base} bg-[#25D366] text-white hover:bg-[#1eb856]`;

export const CallCTA = ({ label, className = btnPrimary, testId = "call-cta" }) => (
  <a data-testid={testId} href={telLink} className={className}>
    <Phone size={18} aria-hidden="true" />
    {label || `Call ${SITE.phone}`}
  </a>
);

export const WhatsAppCTA = ({ label = "WhatsApp Us", message, className = btnWhatsApp, testId = "whatsapp-cta" }) => (
  <a data-testid={testId} href={waLink(message)} target="_blank" rel="noopener noreferrer" className={className}>
    <MessageCircle size={18} aria-hidden="true" />
    {label}
  </a>
);

export const BookCTA = ({ label = "Book a Test", className = btnDark, testId = "book-test-cta" }) => (
  <Link data-testid={testId} to="/book-a-test" className={className}>
    <CalendarCheck size={18} aria-hidden="true" />
    {label}
  </Link>
);
